import { Nullable } from "@jamesgmarks/utilities";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from "@mui/material";

interface IDeleteGroupModalProps {
  groupToDelete: Nullable<number>,
  onClose: () => void
  onDelete: (groupId: number) => void
}
export const DeleteGroupModal: React.FC<IDeleteGroupModalProps> = ({ groupToDelete, onClose, onDelete }) => {
  return (
    <Dialog
      open={groupToDelete !== null}
      onClose={onClose}
    >
      <DialogTitle>Delete Group</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>Group #{groupToDelete}</strong>?
          This will remove all subscriptions from the group.
          Please make sure you save the invoice groups after deleting
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => onDelete(groupToDelete!)}
          color="error"
          variant="contained"
          disabled={!groupToDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};